import { render, staticRenderFns } from "./WDGForm.vue?vue&type=template&id=ad8d3e0c&"
import script from "./WDGForm.vue?vue&type=script&lang=js&"
export * from "./WDGForm.vue?vue&type=script&lang=js&"
import style0 from "./WDGForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../prospect-setup/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports